import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { desktopCommonStyles, mobileCommonStyles, tabletCommonStyles } from '../commonStyles';
import { DrawerVariant } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    [DrawerVariant.DEFAULT]: {
        [DeviceBreakpointsType.DESKTOP]: {
            ...desktopCommonStyles(FOUNDATIONS, SHADOWS),
        },
        [DeviceBreakpointsType.TABLET]: {
            ...tabletCommonStyles(FOUNDATIONS, SHADOWS),
        },
        [DeviceBreakpointsType.MOBILE]: {
            ...mobileCommonStyles(FOUNDATIONS, SHADOWS),
        },
    },
});
//# sourceMappingURL=default.js.map